import React, { Component } from 'react';
import { APP_CONST } from '../../../../constants';
import { GeckoFields } from '../../../../components';
import Commands from '../ModuleTwoFactor/Commands';

export class ModuleBasic extends Component {
    constructor(props) {
        super(props);

        this.removePhoneNumber = this.removePhoneNumber.bind(this);
        this.renderRemoveNumber = this.renderRemoveNumber.bind(this);
    }

    handleChange(name, evt) {
        this.setState({[name]: evt});
    }

    fields()
    {
        return [{
            label: 'First Name',
            key: 'first_name',
            width: '100%',
            disabledWhen: () => true,
            type: APP_CONST.FIELD_TYPE_TEXT,
        },{
            label: 'Last Name',
            key: 'last_name',
            width: '100%',
            disabledWhen: () => true,
            type: APP_CONST.FIELD_TYPE_TEXT,
        },{
            label: 'Email Address',
            key: 'email',
            width: '100%',
            disabledWhen: () => true,
            type: APP_CONST.FIELD_TYPE_EMAIL,
        },{
            label: 'Phone Number',
            key: 'number',
            width: '100%',
            disabledWhen: () => true,
            type: APP_CONST.FIELD_TYPE_TEL,
            description:  this.renderRemoveNumber(),
        },];
    }

    renderRemoveNumber() {
        if (!this.props.data || !this.props.data.user) {
            return null;
        }

        const user = this.props.data.user;

        if (!this.hasPhoneNumber(user)) {
            return null;
        }

        if (this.hasMfaConfigured(user) && this.hasPhoneNumber(user)) {
            return <a className="basicLink" onClick={() => this.props.setAlert('Disable MFA before removing phone number')}>Remove Number</a>
        }

        if (!this.hasMfaConfigured(user) && this.hasPhoneNumber(user)) {
            return <a className="basicLink" onClick={this.removePhoneNumber}>Remove Number</a>
        }
    }

    removePhoneNumber() {
        return Commands.setPhoneNumber('')
        .then(() => {
            this.props.iam();
        })
        .catch((err) => {
            this.props.setAlert(err.message);
        });
    }

    getValues()
    {
        if(!this.props.data || !this.props.data.user) {
            return {}
        }

        const user_data = this.props.data.user;
        const provider_data = (user_data.provider ? user_data.provider : {});

        return {
            first_name: user_data.FirstName,
            last_name: user_data.LastName,
            email: user_data.Email,
            number: provider_data.phone_number ? provider_data.phone_number : '',
        }
    }

     hasMfaConfigured(user) {
        if (user && user.provider && user.provider.UserMFASettingList) {
            return true;
        }

        return false;
    }
    
    hasPhoneNumber(user) {
        if (user && user.provider && user.provider.phone_number) {
            return true;
        }

        return false;
    }  

    render() {
        return (
            <div>
                <GeckoFields 
                    fields={this.fields()}
                    values={this.getValues()}
                    handler={this.handleChange.bind(this)}
                    submitHandler={() => {}} />
            </div>
        )
    }
}

ModuleBasic.defaultProps = {
    data: {},
    setAlert: () => null,
    iam: () => null,
}

export default ModuleBasic;